<template>
  <section>
    <!-- <div class="w-full mt-4 mb-2">
      <h2 class="text-lg font-medium capitalize">
        tops 10 ips
      </h2>
    </div> -->
    <div class="box w-full" style="overflow:hidden;">
      <div
      id="grafica"
      ref="elGrafica"
      style="height:450px;"
      class="w-full"
      />
    </div>
  </section>
</template>

<script>
import * as echarts from 'echarts'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { apiTopIps } from '../../services'
// import { truncate } from 'lodash'
import { useStore } from 'vuex'
import currency from 'currency.js'
import axios from 'axios'
import { messageWarning } from '../../../../../../../libs/mensajes'
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {
    const gradesRotation = ref(0)
    const positionLabel = ref('insideTop')
    const distanceLabel = ref(10)
    const colorLabel = ref('white')
    const store = useStore()
    const isDark = computed(() => {
      return store.getters['main/darkMode']
    })
    /*
    * Refs and reactives
    */
    const elGrafica = ref(null)
    let chart = reactive({})
    const chartData = ref([])
    /*
    * Computeds
    */

    /*
    * Methods
    */
    const initChart = () => {
      gradesRotation.value = (window.innerWidth < 1000) ? 90 : 0
      positionLabel.value = (window.innerWidth < 1000) ? 'top' : 'top'
      distanceLabel.value = (window.innerWidth < 1000) ? 25 : 10
      colorLabel.value = (window.innerWidth < 1000 && !isDark.value) ? 'gray' : 'gray'
      chart = echarts.init(elGrafica.value, isDark.value ? 'dark' : 'light')
      const option = {
        backgroundColor: isDark.value ? '#313A55' : '',
        grid: {
          left: -50,
          right: 15,
          bottom: 50,
          top: 85,
          containLabel: true
        },
        title: {
          text: 'TOP 10 IPS',
          top: 15,
          left: 15
          // subtext: ''
        },
        toolbox: {
          top: 15,
          right: 15,
          feature: {
            myTool1: {
              show: true,
              right: 15,
              top: 10,
              title: 'Detallado',
              icon: 'image:///images/excel.png',
              onclick: () => {
                descargarExcel()
              }
            },
            dataZoom: {
              yAxisIndex: 'none'
            },
            saveAsImage: {}
          }
        },
        tooltip: {
          formatter (a) {
            return `${a.name.split(' ').join('<br>')} <br> ${currency(a.value, { precision: 0, separator: '.' }).format()}`
          }
        },
        legend: { },
        xAxis: {
          data: [],
          axisLabel: {
            interval: 0,
            fontSize: 10,
            height: 20,
            width: 70,
            overflow: 'break'
            // formatter (value) {
            //   return value.split(' ').join('\n')
            // }
          }
        },
        yAxis: [
          {
            show: false
          }
        ],
        series: [
          {
            // name: 'Sales',
            type: 'bar',
            showBackground: true,
            data: [],
            label: {
              show: true,
              color: colorLabel.value,
              formatter (d) {
                return `${currency(d.value / 1000000, { precision: 0, separator: '.' }).format()}M`
              },
              position: positionLabel.value,
              rotate: gradesRotation.value,
              verticalAlign: 'middle',
              distance: distanceLabel.value
            }
          }
        ]
      }
      if (window.innerWidth < 1024) {
        option.xAxis.show = false
      }
      chart.setOption(option)
      loadEvents()
    }
    const loadEvents = () => {
      window.addEventListener('resize', evt => {
        gradesRotation.value = (evt.target.innerWidth < 1000) ? 90 : 0
        positionLabel.value = (evt.target.innerWidth < 1000) ? 'top' : 'top'
        distanceLabel.value = (evt.target.innerWidth < 1000) ? 25 : 10
        colorLabel.value = (window.innerWidth < 1000 && !isDark.value) ? 'gray' : 'gray'
        reloadChart()
        chart.resize()
      })
    }

    const reloadChart = () => {
      const option = {
        xAxis: {
          data: getChartLabels()
        },
        series: [
          {
            data: getChartData(),
            label: {
              show: true,
              color: colorLabel.value,
              formatter (d) {
                return `${currency(d.value / 1000000, { precision: 0, separator: '.' }).format()}M`
              },
              position: positionLabel.value,
              rotate: gradesRotation.value,
              verticalAlign: 'middle',
              distance: distanceLabel.value
            }
          }
        ]
      }
      option.xAxis.show = true
      if (window.innerWidth < 1024) {
        option.xAxis.show = false
      }
      chart.setOption(option)
    }

    const getChartLabels = () => {
      return chartData.value.map(a => a.Entidad)
    }

    const getChartData = () => {
      return chartData.value.map(a => a.Total)
    }

    const fetchIps = () => {
      return apiTopIps(props.filters).then(({ data }) => {
        chartData.value = data
        reloadChart()
      }).catch((err) => {
        console.error(err.message)
      })
    }

    const descargarExcel = () => {
      if (!props.filters.client) {
        messageWarning('Por favor seleccione un cliente para generar el reporte en excel')
        return false
      }
      const url = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}/execution-report/top-ips-xls`
      const res = axios.getUri({ url, params: props.filters })
      window.open(res, '_blank')
    }

    /*
    * Hooks
    */
    watch(props.filters, (filter) => {
      if ([null, undefined, ''].includes(filter.client) ||
        [null, undefined, ''].includes(filter.year)
      ) return

      fetchIps()
    })

    onMounted(() => {
      initChart()
      // fetchIps()
    })
    return {
      elGrafica
    }
  }
}
</script>

<style>

</style>
